var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg555Bf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.133 219.813H74.941V281.005H136.133V219.813Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.44 305.481H75.247V366.672H136.44V305.481Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.592 391.149H75.4V452.341H136.592V391.149Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.057 134.144H74.865V195.336H136.057V134.144Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.018 48.474H74.827V109.666H136.018V48.474Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M413.248 249.918C418.176 173.26 487.182 59.755 354.514 59.755C243.377 59.755 235.919 155.947 235.919 249.918C235.919 334.887 239.963 436.504 342.446 440.081C485.316 445.067 418.725 335.106 413.248 249.918Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg555Bf);
export default __webpack_public_path__ + "static/media/555bf.134d2c4306c36db46e06e9ddea8b5ae4.svg";
export { ForwardRef as ReactComponent };